<template>
  <form @submit.prevent="submit">
    <AppInput v-model="searchText" :placeholder="placeholder" @blur="submit">
      <template #suffixAction>
        <div class="flex h-10 shrink-0 items-center">
          <button
            v-if="searchText.length > 0"
            type="button"
            class="flex h-10 w-10 shrink-0 items-center justify-center text-main-80 hover:bg-main-10 focus:outline-none"
            :aria-label="t('actions.clearSearch')"
            @click="emit('update:modelValue', '')"
          >
            <font-awesome-icon :icon="faTimes" />
          </button>
          <button
            type="submit"
            class="flex h-10 w-10 shrink-0 items-center justify-center text-main-80 hover:bg-main-10 focus:outline-none"
            :aria-label="t('actions.search')"
            :class="searchText.length > 0 && 'border-l border-main-40'"
          >
            <font-awesome-icon :icon="faSearch" />
          </button>
        </div>
      </template>
    </AppInput>
  </form>
</template>

<script lang="ts" setup>
import { faSearch, faTimes } from '@fortawesome/free-solid-svg-icons';
import { ref, watch } from 'vue';
import { useI18n } from 'vue-i18n';

import AppInput from './AppInput.vue';

const { t } = useI18n();

/**
 * Props for the AppSearchInput component
 */
export interface AppSearchInputProps {
  /** The model value of the search input */
  modelValue: string;
  /** The placeholder text for the search input */
  placeholder: string;
}

const emit = defineEmits(['update:modelValue']);
const props = defineProps<AppSearchInputProps>();

const searchText = ref(props.modelValue);

function submit() {
  emit('update:modelValue', searchText.value);
}

watch(
  () => props.modelValue,
  (newValue) => {
    searchText.value = newValue;
  }
);
</script>
